import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CloudFile } from '../../../../_models/files';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../../../_models/user-profile';
import { UserProfileService } from '../../../../_services/user-profile.service';
import { PortalApiService } from '../../../../_services/portal-api.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent {
  @Input() storageType: string;
  @Input() wellID?: number;

  @Output() fileUploadSucceeded: EventEmitter<CloudFile> = new EventEmitter();
  userProfile: UserProfile;
  fileUploadInitiated: boolean = false;
  fileToUpload: FormData;
  selectedFile: File;
  fileUpload: any;
  fileData: CloudFile = new CloudFile;
  fileSize: any;
  errorUploadMessage: string;
  showAddWellFile: boolean = false;
  private onDestroy$ = new Subject<void>();

  constructor(
    private apiService: PortalApiService,
    private userService: UserProfileService,
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(currentProfile => { this.userProfile = currentProfile });
  }

  ngOnInit(): void {
    this.fileData.isAttachment = true;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  addFile() {
    if (!this.fileUploadInitiated) {
      document.getElementById('fileUpload').click();
      this.errorUploadMessage = null;
    }
  }

  onFileDropped(event) {
    this.handleFileInput(event);
  }

  handleFileInput(files: File[]) {
    this.errorUploadMessage = null;
    let formData: FormData = new FormData();
    if (files.length > 1) {
      this.errorUploadMessage = "Please select one file at a time to upload.";
    }
    else {
      if (!this.checkIfFileIsAuthorized(files[0])) {
        this.errorUploadMessage = "Failed to select file. It exceeds the maximum upload size of 30 MB.";
      }
      else {
        this.selectedFile = files[0];
        formData.append("asset", files[0], files[0].name);
        this.fileToUpload = formData;
      }
    }
  }

  handleToggleIsAttachment(value: boolean) {
    this.fileData.isAttachment = value;
  }

  checkIfFileIsAuthorized(file: File): boolean {
    // Max file size is 30 MB currently
    const maxFileSize = 31457280;
    let fileSize = file.size;
    if (fileSize >= maxFileSize) {
      return false;
    }
    this.fileSize = fileSize;
    return true;
  }

  onUploadFile() {
    this.fileUploadInitiated = true;

    if (this.fileToUpload == undefined) {
      this.fileUploadInitiated = false;
      this.errorUploadMessage = "An error occurred. Failed to upload file.";
      return false;
    }
    else {
      switch (this.storageType) {
        case 'well':
          this.uploadFileForWell();
          break;
        default:
          break;
      }
    }
  }

  private uploadFileForWell() {
    this.apiService.addFileForWell(this.wellID, this.fileToUpload).subscribe({
      next: data => {
        let fileName: string = data["fileName"];
        this.fileData.fileName = fileName;
        this.fileData.isAttachment = false;
        this.fileData.createdByID = this.userProfile.id;
        this.fileData.createdOn = new Date();
        this.fileData.lastUpdateByID = this.userProfile.id;
        this.fileData.lastUpdateTime = new Date();
        this.fileData.size = this.fileSize;

        this.apiService.updateFileDataForWell(this.wellID, fileName, this.fileData).subscribe({
          next: data => {
            this.fileUploadSucceeded.emit(this.fileData);
            this.fileUploadInitiated = false;
            this.resetFileAndFileData(this.fileData.isAttachment);
          },
          error: err => {
            console.log(err);
            this.fileUploadInitiated = false;
          }
        });
      },
      error: err => {
        console.log(err);
        this.errorUploadMessage = (err.error || 'An error occurred. Failed to upload file.');
        this.fileUploadInitiated = false;
      }
    })
  }

  resetFileAndFileData(lastAttachmentStatus?: boolean) {
    this.showAddWellFile = false;
    this.selectedFile = null;
    this.errorUploadMessage = null;
    this.fileToUpload = null;
    this.fileData = new CloudFile;
    if (lastAttachmentStatus) {
      this.fileData.isAttachment = lastAttachmentStatus;
    }
  }

  onAddWellFile() {
    this.showAddWellFile = true;
  }
}
